import { Injectable } from "@angular/core";
import { LocalStorage } from "@core/browser";
import { AdvancedReportService, Status, translateCommonErrorStatus } from "@core/data";
import { AdvancedReport, SHARE_KEY_HEADER } from "@core/data/types/advanced-report";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";

export interface AdvancedReportPreviewStateModel {
    status: Status;
    shareKey: string;
    data: Partial<AdvancedReport>;
}

const DEFAULTS: AdvancedReportPreviewStateModel = {
    status: Status.UNINITIALIZED,
    shareKey: null,
    data: null,
}

export class InitAdvancedReportPreview {
    static readonly type = "[AdvancedReportPreviewState] Init Preview";
    constructor(public shareKey: string) {}
}

export class LoadAdvancedReportPreview {
    static readonly type = '[AdvancedReportPreviewState] Preview Report';
    constructor() {}
}

@State({
    name: 'advanced_report_preview',
    defaults: DEFAULTS
})
@Injectable()
export class AdvancedReportPreviewState {
    constructor(
        private _reportService: AdvancedReportService,
    ) {}

    @Selector()
    static shareKey(state: AdvancedReportPreviewStateModel) {
        return state.shareKey;
    }

    @Action(InitAdvancedReportPreview)
    initAdvancedReportPreview(ctx: StateContext<AdvancedReportPreviewStateModel>, action: InitAdvancedReportPreview) {
        if(!action.shareKey) {

            return ctx.patchState({
                ...DEFAULTS,
                status: Status.NOT_FOUND,
            });
        }

        ctx.patchState({
            shareKey: action.shareKey,
        });

        return ctx.dispatch(new LoadAdvancedReportPreview())

    }

    @Action(LoadAdvancedReportPreview)
    loadAdvancedReportPreview(ctx: StateContext<AdvancedReportPreviewStateModel>, action: LoadAdvancedReportPreview) {
        let state = ctx.getState();

        ctx.patchState({
            status: Status.LOADING,
        });

        return this._reportService.getShared(state.shareKey)
            .pipe(
                tap(
                    result => {
                        ctx.patchState({
                            status: Status.OK,
                            data: result,
                        });
                    },
                    error => {
                        ctx.patchState({
                            status: translateCommonErrorStatus(error),
                        });
                    }
                )
            )

    }
}